import { apiRequest } from './client';
import type { User } from '../types/api';

export interface LoginResponse {
  user: User;
}

export interface MeResponse {
  kind: 'human' | 'apiToken';
  user?: User;
  apiToken?: { id: string; name: string; scopes: string[] };
}

export const authApi = {
  login: (email: string, password: string) =>
    apiRequest<LoginResponse>('/auth/login', { method: 'POST', body: { email, password } }),

  logout: () => apiRequest<{ ok: true }>('/auth/logout', { method: 'POST' }),

  me: () => apiRequest<MeResponse>('/auth/me'),
};
